package com.bikompanion.data.gbfs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class GbfsVehicleTypesData(
    @SerialName("vehicle_types") val vehicleTypes: List<GbfsVehicleTypeDto>,
)
